import { FormattedMessage } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import policy from '@/pages/legal/assets/policy.md?raw'
import { MarkdownWrapper } from '@/pages/legal/components/markdown-wrapper'
export const PolicyRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <div className="flex flex-col gap-8 sm:gap-6">
      <Typography
        gutterBottom
        component="h1"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <FormattedMessage id="common.controls.privacyPolicy" />
      </Typography>

      <MarkdownWrapper markdown={policy} />
    </div>
  )
}
